'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListTypeSelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _listTypeCover = require('../../list-type-cover');

var _listTypeCover2 = _interopRequireDefault(_listTypeCover);

require('../styles/ListTypeSelector.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListTypeSelector = exports.ListTypeSelector = function (_BcReactComponent) {
  _inherits(ListTypeSelector, _BcReactComponent);

  function ListTypeSelector(props) {
    _classCallCheck(this, ListTypeSelector);

    var _this = _possibleConstructorReturn(this, (ListTypeSelector.__proto__ || Object.getPrototypeOf(ListTypeSelector)).call(this, props));

    _this.state = {
      showShelfMessage: false,
      showAdminListTypes: false
    };
    _this.bindAll('handleOverlayClose', 'handleOverlayOpen', 'setListType', 'handleShowAdminListTypes');
    return _this;
  }

  _createClass(ListTypeSelector, [{
    key: 'renderDescriptionForType',
    value: function renderDescriptionForType(type) {
      if (!this.state.showAdminListTypes) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_type_description_' + type });
      }

      return null;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this._newListTitle) {
        this._newListTitle.focus();
      }
    }
  }, {
    key: 'handleOverlayClose',
    value: function handleOverlayClose(e) {
      if (e) {
        e.preventDefault();
      }
      this.setState({ showShelfMessage: false });
    }
  }, {
    key: 'handleOverlayOpen',
    value: function handleOverlayOpen() {
      this.setState({ showShelfMessage: true });
    }
  }, {
    key: 'handleShowAdminListTypes',
    value: function handleShowAdminListTypes() {
      this.setState({ showAdminListTypes: true });
    }
  }, {
    key: 'setListType',
    value: function setListType(listType) {
      this.props.handleListTypeClicked(_immutable2.default.Map({ listType: listType }));
    }
  }, {
    key: 'getListTypesToDisplay',
    value: function getListTypesToDisplay() {
      return this.state.showAdminListTypes ? this.props.adminListTypes : this.props.listTypes;
    }
  }, {
    key: 'renderShowAdminListsButton',
    value: function renderShowAdminListsButton() {
      if (!this.state.showAdminListTypes && this.props.adminListTypes.size > 0) {
        return _react2.default.createElement(_listTypeCover2.default, {
          key: 'admin-lists',
          type: 'admin_lists',
          description: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_admin_types_description' }),
          handleClick: this.handleShowAdminListTypes });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-list-type-selector' },
        _react2.default.createElement(
          'div',
          { className: 'header' },
          _react2.default.createElement(
            'h1',
            { tabIndex: '-1', ref: function ref(el) {
                return _this2._newListTitle = el;
              } },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_new_list' })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'lists-intro' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_choose_type' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'list-types' },
          this.getListTypesToDisplay().map(function (type) {
            return _react2.default.createElement(_listTypeCover2.default, {
              key: type,
              type: type,
              description: _this2.renderDescriptionForType(type),
              handleClick: _this2.setListType });
          }),
          this.renderShowAdminListsButton()
        )
      );
    }
  }]);

  return ListTypeSelector;
}(_baseBcReactComponent2.default);

ListTypeSelector.propTypes = {
  adminListTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  listTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  handleListTypeClicked: _react2.default.PropTypes.func
};

exports.default = ListTypeSelector;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-type-selector/components/ListTypeSelector.component.js
// module id = 1317
// module chunks = 0